module.exports = __webpack_public_path__ + "img/background-deep.1c6c0629.jpg";